import { PassouFalhouEnum } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/consulta-seguimento/enums-consultaSeguimento'
import { calculateResultadoPergunta12 } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/consulta-seguimento/perguntas/consulta-seguimento-pergunta-12/utils-consultaSeguimentoPergunta12'
import { MchatRfAplicacaoQueryModel } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/model-mChatRf'

import { HistoricoMchatExemplosPassouFalhouTableItem } from '../components/HistoricoMchatExemplosPassouFalhouTableItem'
import { HistoricoMChatHeaderTableItem } from '../components/HistoricoMchatHeaderTableItem'
import { HistoricoMChatPerguntaSection } from '../components/HistoricoMchatPerguntaSection'
import { HistoricoMChatResultadoParcialTableItem } from '../components/HistoricoMChatResultadoParcialTableItem'
import { HistoricoMChatSimpleHorizontalTableItem } from '../components/HistoricoMChatSimpleHorizontalTableItem'
import { HistoricoMChatSimpleVerticalTableItem } from '../components/HistoricoMChatSimpleVerticalTableItem'
import { HistoricoMchatTwoColumnsEvenlyTableItem } from '../components/HistoricoMchatTwoColumnsEvenlyTableItem'
import { convertAplicacaoPergunta12 } from './converter-HistoricoMchatPergunta12'

interface HistoricoMChatRfPergunta12Props {
  aplicacoes: ReadonlyArray<MchatRfAplicacaoQueryModel>
}

export const HistoricoMChatRfPergunta12 = (props: Readonly<HistoricoMChatRfPergunta12Props>) => {
  const { aplicacoes } = props

  const converted = convertAplicacaoPergunta12(aplicacoes)
  if (converted == null) return null

  const { header, exemplos, exemplosPassou, exemplosFalhou, perguntaMaiorFrequencia, model } = converted
  if (header === null) return null

  const exibirPergunta = header.stPassou ? '“A criança tem uma reação negativa ao som de...”' : undefined
  const exibirExemplos = exemplos.length > 0
  const exibirPassouFalhou = exemplosPassou.length > 0 || exemplosFalhou.length > 0

  const resultado = calculateResultadoPergunta12(model)

  return (
    <HistoricoMChatPerguntaSection>
      <HistoricoMChatHeaderTableItem
        numeroPergunta='12'
        title={header.textoPergunta}
        value={header.stPassou}
        pergunta={exibirPergunta}
      />
      {exibirExemplos && <HistoricoMchatTwoColumnsEvenlyTableItem perguntas={exemplos} />}
      {exibirPassouFalhou && <HistoricoMChatSimpleVerticalTableItem pergunta='“A criança...”' resposta={undefined} />}
      {exibirPassouFalhou && (
        <HistoricoMchatExemplosPassouFalhouTableItem exemplosPassou={exemplosPassou} exemplosFalhou={exemplosFalhou} />
      )}
      {perguntaMaiorFrequencia && (
        <HistoricoMChatSimpleHorizontalTableItem
          pergunta={perguntaMaiorFrequencia.textoPergunta + ':'}
          resposta={'Exemplos ' + (perguntaMaiorFrequencia.stPassou ? 'PASSOU' : 'FALHOU')}
        />
      )}
      {resultado && <HistoricoMChatResultadoParcialTableItem valor={resultado === PassouFalhouEnum.PASSOU} />}
    </HistoricoMChatPerguntaSection>
  )
}
